import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { OeeRemarkItem, OeeService } from '@app/services/oee.service';

@Component({
    selector: 'tt-select-oee-state-remark',
    templateUrl: './select-oee-state-remark.component.html',
    styleUrls: ['./select-oee-state-remark.component.css'],
    standalone: false
})
export class SelectOeeStateRemarkComponent implements OnInit {
    public items: OeeRemarkItem[] = [];

    public selecting = false;

    public error = '';

    public canSelect = () => !this.selecting;

    constructor(
        private oee: OeeService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async ngOnInit(): Promise<void> {
        try { this.items = await this.oee.getRemarks(String(this.navigator?.params['oeestate_keyno'] ?? '')); }
        catch (error) { this.showError(error); }
    }

    public async select(item: OeeRemarkItem): Promise<void> {
        if (this.selecting || item.item_id === '') return;

        this.selecting = true;
        this.error = '';

        try {
            this.oee.selectRemark(item);
            await this.navigator?.back();
        } catch (error) {
            this.showError(error);
        } finally {
            this.selecting = false;
        }
    }

    private showError(error: unknown): void {
        this.error = error instanceof Error ? error.message : String(error);
    }
}
